// Tooltip text for various components in the application

export const dashboardTooltips = {
  quickTimeFilters: "Filter trades by standard time ranges like today, this week, or last month.",
  filterByTags: "Tags help group trades by strategy, style, or execution patterns.",
  category: "Choose asset class: crypto, stock, forex, etc.",
  status: "Select trade status: open, closed, or in review.",
  strategy: "Filter trades by applied trading strategy.",
  symbol: "Enter or select a trading pair or asset."
};

export const aiTradeCreatorTooltips = {
  // Step 1: Upload Screenshot
  pasteScreenshot: "You can drag, paste, or upload your chart image for AI analysis.",
  
  // Step 2: AI Analysis
  analyzeScreenshot: "Extract trade details like entry, stop loss, and price levels from your chart.",
  skipAnalysis: "Skip AI extraction and enter trade details manually.",
  
  // Step 3: Trade Details
  tradeFields: {
    symbol: "Enter trading pair or asset name (e.g., BTCUSDT, AAPL).",
    exchange: "Optional: mention where the trade was executed.",
    entryPrice: "Price at which the trade was entered or exited.",
    exitPrice: "Price at which the trade was entered or exited.",
    stopLoss: "Price to exit the trade to limit loss.",
    positionSize: "Total size or amount of the asset traded.",
    direction: "Long = buying to sell higher, Short = selling to buy lower.",
    leverage: "Optional: leverage multiplier used for the trade.",
    pnlAmount: "Total profit or loss from this trade.",
    status: "Mark trade as Open, Closed, or In Review.",
    tradeDate: "Date and time when the trade was opened.",
    closeDate: "Date and time when the trade was closed.",
    strategy: "Link this trade to a saved strategy for performance tracking.",
    setup: "Describe the technical pattern or signal used for entry.",
    insight: "Optional: describe your thought process or learnings.",
    notes: "Optional: journal your key lessons or emotional reactions.",
    tags: "Use tags like 'Breakout', 'Scalp', 'Whale School' for future analysis."
  }
};

export const aiFeedbackTooltips = {
  loadFeedback: "Load previously generated feedback on saved trades.",
  generateNewFeedback: "Let AI review your trade and suggest improvements.",
  performanceScore: "Overall assessment of trade quality and discipline.",
  suggestedActions: "Practical coaching tips to improve future trades."
};

export const strategyManagementTooltips = {
  strategyName: "Name of your strategy (e.g., VWAP, ORB).",
  description: "Brief summary of what the strategy aims to do.",
  entryCriteria: "What signals or setups prompt a trade entry.",
  exitCriteria: "Conditions under which you exit the trade.",
  tradingViewUrl: "Optional: link to TradingView chart or script.",
  tags: "Keywords to describe or organize the strategy."
};

export const calendarTooltips = {
  calendarView: "Visualize daily trade outcomes with P&L and win rate.",
  colorCoding: "Green = winning day, Red = losing day, Blue = no strategy assigned."
};

export const planUsageTooltips = {
  tradeQuota: "Number of trades you can add under the current plan.",
  aiTradeAnalysis: "Limit for AI-based chart extraction.",
  aiFeedback: "Coaching feedback limit for this billing cycle."
};